import './App.css';

function App() {
  return (
    <div className="meadow-landing">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-left">
              <div className="badge">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 2L9.5 6.5L14 8L9.5 9.5L8 14L6.5 9.5L2 8L6.5 6.5L8 2Z" fill="#81A684"/>
                </svg>
                <span>Growing together</span>
              </div>
              <h1>Simplify your childcare center management</h1>
              <p className="hero-description">
                Connect teachers and parents with an all-in-one platform for photos, messaging, billing, and classroom management.
              </p>
              <div className="hero-buttons">
                <button className="btn-primary">Start Free Trial</button>
                <button className="btn-secondary">Watch Demo</button>
              </div>
              <div className="trust-indicators">
                <div className="avatar-group">
                  <div className="avatar"></div>
                  <div className="avatar"></div>
                  <div className="avatar"></div>
                  <div className="avatar"></div>
                </div>
                <div className="trust-text">
                  <div className="stars">★★★★★</div>
                  <p>Trusted by 1,000+ centers</p>
                </div>
              </div>
            </div>
            <div className="hero-right">
              <div className="hero-image-card">
                <img src="https://www.figma.com/api/mcp/asset/1e362373-fc11-4c8f-a86b-3e7a9f458f88" alt="Children learning" />
                <button className="floating-heart">❤️</button>
                <div className="floating-notification">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18 8C19.1 8 20 8.9 20 10V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V10C4 8.9 4.9 8 6 8H8V6C8 3.8 9.8 2 12 2C14.2 2 16 3.8 16 6V8H18ZM12 4C10.9 4 10 4.9 10 6V8H14V6C14 4.9 13.1 4 12 4Z" fill="#81A684"/>
                  </svg>
                  <span>3 new updates</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <h2>Everything you need in one place</h2>
            <p>Streamline daily operations with our comprehensive suite of tools designed for early childhood education.</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon coral">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#F2937E">
                  <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
                </svg>
              </div>
              <h3>Photo Sharing</h3>
              <p>Capture and share precious moments instantly. Parents receive real-time photo updates of their child's day.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon green">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#81A684">
                  <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
                </svg>
              </div>
              <h3>Messaging</h3>
              <p>Seamless communication between teachers and parents. Send updates, announcements, and direct messages.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon blue">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#7FBBDA">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
                </svg>
              </div>
              <h3>Billing & Payments</h3>
              <p>Automated billing, payment processing, and financial reporting. Accept cards, ACH, and more.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon coral">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#F2937E">
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div>
              <h3>Classroom Management</h3>
              <p>Track attendance, activities, meals, and naps. Everything teachers need at their fingertips.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon green">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#81A684">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <h3>Center Administration</h3>
              <p>Complete oversight with analytics, reporting, and multi-classroom management tools.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon blue">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#7FBBDA">
                  <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"/>
                </svg>
              </div>
              <h3>Schedule & Events</h3>
              <p>Manage calendars, events, and important dates. Automated reminders for everyone.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="section-header">
            <h2>Save time and money</h2>
            <p>Centers using Meadow see dramatic improvements in efficiency and parent satisfaction.</p>
          </div>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">⏱️</div>
              <div className="stat-number">15hrs</div>
              <h4>Saved per week</h4>
              <p>Automate administrative tasks</p>
            </div>
            <div className="stat-card">
              <div className="stat-icon">💰</div>
              <div className="stat-number">$3500+</div>
              <h4>Monthly savings</h4>
              <p>Reduce operational costs</p>
            </div>
            <div className="stat-card">
              <div className="stat-icon">❤️</div>
              <div className="stat-number">98%</div>
              <h4>Parent satisfaction</h4>
              <p>Improved communication</p>
            </div>
          </div>
        </div>
      </section>

      {/* Roles Section */}
      <section className="roles-section">
        <div className="container">
          <div className="section-header">
            <h2>Built for everyone</h2>
            <p>Meadow adapts to your role, whether you're running a center, teaching a classroom, or staying connected as a parent.</p>
          </div>
          <div className="roles-grid">
            <div className="role-card">
              <div className="role-image">
                <img src="https://www.figma.com/api/mcp/asset/b9a8d6b6-3e08-4de1-aa17-95c4c68895f7" alt="Center Administrators" />
                <div className="role-overlay"></div>
                <h3>Center Administrators</h3>
              </div>
              <ul className="role-features">
                <li>✓ Multi-classroom oversight</li>
                <li>✓ Financial reporting & analytics</li>
                <li>✓ Staff management tools</li>
                <li>✓ Parent billing automation</li>
                <li>✓ Compliance & documentation</li>
              </ul>
            </div>
            <div className="role-card">
              <div className="role-image">
                <img src="https://www.figma.com/api/mcp/asset/9a3d8262-11cb-4cf4-8144-9be5cd285765" alt="Teachers" />
                <div className="role-overlay"></div>
                <h3>Teachers</h3>
              </div>
              <ul className="role-features">
                <li>✓ Daily activity logging</li>
                <li>✓ Photo & video sharing</li>
                <li>✓ Attendance tracking</li>
                <li>✓ Parent communication</li>
                <li>✓ Lesson planning tools</li>
              </ul>
            </div>
            <div className="role-card">
              <div className="role-image">
                <img src="https://www.figma.com/api/mcp/asset/5af2b6c5-6f96-4274-810e-845c5c4dfcce" alt="Parents" />
                <div className="role-overlay"></div>
                <h3>Parents</h3>
              </div>
              <ul className="role-features">
                <li>✓ Real-time photo updates</li>
                <li>✓ Direct teacher messaging</li>
                <li>✓ Activity feed & reports</li>
                <li>✓ Easy payment options</li>
                <li>✓ Event notifications</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="container-narrow">
          <div className="section-header">
            <h2>Transparent pricing</h2>
            <p>One simple plan. No hidden fees. Cancel anytime.</p>
          </div>
          <div className="pricing-card">
            <span className="popular-badge">⭐ Most Popular</span>
            <h3>Full Center Access</h3>
            <div className="price">
              <span className="amount">$99</span>
              <span className="period">/month</span>
            </div>
            <p className="price-subtitle">per center · unlimited users</p>
            <div className="features-list">
              <div className="features-column">
                <div className="feature-item">✓ Unlimited teachers & staff</div>
                <div className="feature-item">✓ Photo & video sharing</div>
                <div className="feature-item">✓ Billing & payment processing</div>
                <div className="feature-item">✓ Activity logging</div>
                <div className="feature-item">✓ Mobile apps (iOS & Android)</div>
                <div className="feature-item">✓ Data backup & security</div>
              </div>
              <div className="features-column">
                <div className="feature-item">✓ Unlimited parent accounts</div>
                <div className="feature-item">✓ Messaging & announcements</div>
                <div className="feature-item">✓ Attendance tracking</div>
                <div className="feature-item">✓ Analytics & reporting</div>
                <div className="feature-item">✓ Priority support</div>
                <div className="feature-item">✓ Custom branding</div>
              </div>
            </div>
            <button className="btn-cta">Start 30-Day Free Trial</button>
            <p className="fine-print">No credit card required · Setup in minutes</p>
            <div className="discount-notice">
              <p><strong>Small center discounts available</strong></p>
              <p>Centers with 2-3 classrooms qualify for reduced pricing</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2>Loved by centers everywhere</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="quote">"Meadow has transformed how we communicate with parents. The daily photo updates are a huge hit!"</p>
              <div className="author">
                <img src="https://www.figma.com/api/mcp/asset/269565a2-2dd5-470a-8ef0-350f547f7aea" alt="Sarah Johnson" />
                <div>
                  <h4>Sarah Johnson</h4>
                  <p>Director, Little Sprouts Academy</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="quote">"The time savings are incredible. What used to take hours now takes minutes. Highly recommend!"</p>
              <div className="author">
                <img src="https://www.figma.com/api/mcp/asset/8ad12b04-021a-4193-8566-a96a112531cc" alt="Michael Chen" />
                <div>
                  <h4>Michael Chen</h4>
                  <p>Owner, Bright Beginnings</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="quote">"Parents love the app! Engagement has skyrocketed since we switched to Meadow. Best decision we made."</p>
              <div className="author">
                <img src="https://www.figma.com/api/mcp/asset/fa2e6d58-3a5c-4ae8-bd44-f7f460bdbcdf" alt="Emily Rodriguez" />
                <div>
                  <h4>Emily Rodriguez</h4>
                  <p>Lead Teacher, Growing Garden</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container-narrow">
          <h2>Ready to grow together?</h2>
          <p>Join 1,000+ childcare centers using Meadow to create better experiences for teachers, parents, and children.</p>
          <div className="cta-buttons">
            <button className="btn-cta-white">
              Start Free Trial
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#81A684">
                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
              </svg>
            </button>
            <button className="btn-cta-outline">Schedule a Demo</button>
          </div>
          <p className="cta-fine-print">30-day free trial · No credit card required</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <div className="logo-icon"></div>
                <span>Meadow</span>
              </div>
              <p>Growing together</p>
            </div>
            <div className="footer-links">
              <h4>Product</h4>
              <ul>
                <li><a href="#features">Features</a></li>
                <li><a href="#pricing">Pricing</a></li>
                <li><a href="#security">Security</a></li>
                <li><a href="#updates">Updates</a></li>
              </ul>
            </div>
            <div className="footer-links">
              <h4>Company</h4>
              <ul>
                <li><a href="#about">About</a></li>
                <li><a href="#blog">Blog</a></li>
                <li><a href="#careers">Careers</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-links">
              <h4>Support</h4>
              <ul>
                <li><a href="#help">Help Center</a></li>
                <li><a href="#docs">Documentation</a></li>
                <li><a href="#api">API</a></li>
                <li><a href="#status">Status</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
